<template>
  <div class="box">
    <MainHalfTitle text="錯誤"></MainHalfTitle>
    <MainDescribe text="找不到測試者，請重新輸入參考編號或名稱。"></MainDescribe>
  </div>
</template>

<script>
import MainHalfTitle from "../common/MainHalfTitle";
import MainDescribe from "../common/MainDescribe";
export default {
  name: "HomeSearchNoUser",
  components: {MainDescribe, MainHalfTitle}
}
</script>

<style scoped>

</style>